import { useEffect, useRef, useState } from 'react'
import { Search } from 'lucide-react'
import { Input } from '../ui/input'
import { cn } from '@/lib/utils'

export function SupplierSearchInput({
  initialValue = '',
  onDebouncedChange,
  delayMs = 300,
  className,
  registerFocusRef,
}: {
  initialValue?: string
  onDebouncedChange: (value: string) => void
  delayMs?: number
  className?: string
  registerFocusRef?: (el: HTMLInputElement | null) => void
}) {
  const [value, setValue] = useState(initialValue)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const lastEmittedRef = useRef(initialValue)

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      if (lastEmittedRef.current !== value) {
        lastEmittedRef.current = value
        onDebouncedChange(value)
      }
    }, delayMs)
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [value, delayMs, onDebouncedChange])

  return (
    <div className={cn('relative w-full', className)}>
      <Search
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden="true"
      />
      <Input
        ref={registerFocusRef}
        type="search"
        aria-label="Rechercher un fournisseur"
        placeholder="Rechercher par nom, email ou entreprise…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="h-11 pl-9"
      />
    </div>
  )
}
